import { Grid } from '@mui/material';
import CTypography from 'components/CTypography';
import { QuickActionsCnt } from './quickActions.style';
import workOrderImg from 'public/assets/img/workOrder.png';
import spinImg from 'public/assets/img/spin.png';
import exploreTemplatesImg from 'public/assets/img/exploreTemplates.png';

import CustomModal from 'components/CustomModal';
import { useWorkspaceHook } from 'utils/CustomHooks/useWorkspaceHook';
import { useOnboardState } from '../onboarding-provider';
import actions from 'store/actions';
import DIALOGS from 'utils/dialogIds';
import { useDispatch } from 'react-redux';

const QuickActions = (props) => {
  const { nextStep } = props;
  const { navigateWithWorkspaceUrl } = useWorkspaceHook();
  const { hotelId } = useOnboardState();
  const dispatch = useDispatch();
  const handleClose = () => {
    navigateWithWorkspaceUrl('/dashboard', hotelId, {
      replace: true,
    });
  };
  return (
    <CustomModal open={true} handleClose={handleClose} maxWidth={'md'}>
      <QuickActionsCnt>
        <CTypography className="title">Let’s get you up & running!</CTypography>
        <CTypography className="subtitle">
          How would you like to get started?
        </CTypography>

        <Grid container className="actions" spacing={2}>
          <Grid item xs={4}>
            <div
              className="section"
              onClick={() => {
                nextStep({ HotelId: hotelId });
              }}
            >
              <div className="imgCnt">
                <img src={workOrderImg} />
              </div>
              <div className="contentCnt">
                <CTypography className="title">
                  Create Tasks, Work Orders, and Calendars
                </CTypography>
                <CTypography className="details">
                  Learn how to create, assign and report on every task or work
                  order in your organization.
                </CTypography>
              </div>
            </div>
          </Grid>
          <Grid item xs={4}>
            <div
              className="section"
              onClick={() => {
                dispatch(
                  actions.setDialog({
                    dialogId: DIALOGS.TEMPLATE_LIBRARY,
                    open: true,
                  }),
                );
                navigateWithWorkspaceUrl('/checklist', hotelId, {
                  replace: true,
                });
              }}
            >
              <div className="imgCnt">
                <img src={exploreTemplatesImg} />
              </div>
              <div className="contentCnt">
                <CTypography className="title">
                  Explore Operations Templates Library
                </CTypography>
                <CTypography className="details">
                  View hundreds of inspections, checklists, SOPs and logs to
                  guide work and data collection.
                </CTypography>
              </div>
            </div>
          </Grid>
          <Grid item xs={4}>
            <div
              className="section"
              onClick={() => {
                navigateWithWorkspaceUrl('/dashboard', hotelId, {
                  replace: true,
                });
              }}
            >
              <div className="imgCnt">
                <img src={spinImg} />
              </div>
              <div className="contentCnt">
                <CTypography className="title">
                  Take a Spin on Your Own
                </CTypography>
                <CTypography className="details">
                  Take the lead in exploring Xenia to optimize your facility and
                  frontline operations.
                </CTypography>
              </div>
            </div>
          </Grid>
        </Grid>
      </QuickActionsCnt>
    </CustomModal>
  );
};

export default QuickActions;
